import React from 'react';

export function Input({ value, onChange, ...other }) {
  const inputValue = typeof value === 'undefined' ? '' : value;

  return <input {...other} value={inputValue} onChange={onChange} />;
}
